import { z } from 'zod/v4';

export const EMAIL_SCHEMA = z.email();
